import { Chip } from "@mui/material";
import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

const DragItem = ({ itemObject }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: itemObject.id,
    data: { type: "field", name: itemObject.columnName }
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={{
        transform: CSS.Translate.toString(transform),
        opacity: isDragging ? 0 : 1,
        cursor: "grab",
        marginBottom: 8
      }}
    >
      <Chip
        size="small"
        variant="outlined"
        label={itemObject.columnName}
        sx={{
          width: "100%",
          justifyContent: "flex-start",
          cursor: "grab",
          "& .MuiChip-label": {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        }}
      />
    </div>
  );
};

export default DragItem;
